import React, { useEffect } from "react";
import styled from "styled-components";
import CreateDocumentFormHeader from "./CreateDocumentFormHeader";
import CreateDocumentFormFooter from "./CreateDocumentFormFooter";
import CreateDocumentFormField from "./CreateDocumentFormField";
import AttachmentField from "./CreateDocumentFormField/AttachmentField";
import DecisionManagerField from "./CreateDocumentFormField/ApprovalAuthorityField";
import ReferenceField from "./CreateDocumentFormField/ReferenceField";
import ApproverCommentField from "./CreateDocumentFormField/ApproverCommentField";
import { useTempDocumentDetailQuery } from "features/document/hooks/queries/useTempDocumentDetailQuery";
import { DOCUMENT_ALLOWED_EXTENSIONS, DOCUMENT_UUID } from "config/constant";
import {
  ATTACHMENT_FILES,
  DECISION_MANAGER_FIELD_NAME,
  REFERENCE_MEMBER_FIELD_NAME,
} from "config/documentConstant";
import { useFormContext } from "react-hook-form";
import useUserDetailQuery from "features/user/hooks/queries/useUserDetailQuery";

interface CreateDocumentFormBodyProps {
  tempDocumentUuid?: string;
  documentClassUuid?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

const CreateDocumentFormBody = ({
  tempDocumentUuid,
  documentClassUuid,
  actions,
  children,
}: CreateDocumentFormBodyProps) => {
  const { data: user } = useUserDetailQuery();

  const { data: tempDocumentDetail } =
    useTempDocumentDetailQuery(tempDocumentUuid);

  /* 폼 */
  const { register, setValue, watch } = useFormContext();

  useEffect(() => {
    register(ATTACHMENT_FILES);
  }, []);

  return (
    <FormStyle>
      {children}

      <CreateDocumentForm.Footer>
        {tempDocumentDetail?.documentApprove?.comment && (
          <ApproverCommentField
            comment={tempDocumentDetail.documentApprove.comment}
          />
        )}
        {documentClassUuid !== DOCUMENT_UUID.WORK.classes.휴가신청서.uuid && (
          <AttachmentField
            attachments={watch(ATTACHMENT_FILES)}
            uploadParams={{
              fileType: "DOCUMENT_ATTACHMENT",
              isOverwrite: false,
              allowedExtensions: DOCUMENT_ALLOWED_EXTENSIONS,
            }}
            onChangeAttachments={(attachments) => {
              setValue(ATTACHMENT_FILES, attachments);
            }}
          />
        )}

        <DecisionManagerField />
        <ReferenceField
          defaultReferenceUsers={tempDocumentDetail?.referenceUsers || []}
          onChangeReferenceUsers={(referenceUsers) => {
            setValue(
              REFERENCE_MEMBER_FIELD_NAME,
              referenceUsers.map((user) => user.uuid),
            );
          }}
          author={user?.uuid || ""}
          decisionManager={watch(DECISION_MANAGER_FIELD_NAME)}
        />
      </CreateDocumentForm.Footer>

      <FormActionsStyle>{actions}</FormActionsStyle>
    </FormStyle>
  );
};

const CreateDocumentForm = {
  Header: CreateDocumentFormHeader,
  Body: CreateDocumentFormBody,
  Field: CreateDocumentFormField,
  Footer: CreateDocumentFormFooter,
};

export default CreateDocumentForm;

/* 폼 스타일 */
export const FormStyle = styled.form`
  display: flex;
  width: 100%;
  padding: 4rem;
  flex-direction: column;
  gap: 3rem;
  box-sizing: border-box;

  background: ${({ theme }) => theme.color.background.white};
  border-radius: 3rem;

  ${({ theme }) => theme.media.small} {
    padding: 0;
  }
`;

const FormActionsStyle = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;

  ${({ theme }) => theme.media.notSmall} {
    button {
      width: 20rem;
    }
  }
`;
